import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { BorderCollapsedTableWrapper, TBodyWrapper, FlexCenterWrapper, Width50 } from 'wrappers';
import internalState from './internalState';
import { TableRow, Td } from './wrappers';
import { SecondaryTextSm, KeyInput, SecondaryTextSm300, Icon, SecondaryTextXs, SecondaryTextXs300 } from 'atoms';
import { TickSvg } from 'components/icons';
import React from 'react';
import getIsMobile from "components/atoms/utils/getIsMobile"

const isMobile = getIsMobile();

const containerRef = React.createRef();

const tabs = [
  {
    name: 'No tip',
    tip: 0
  },
  {
    name: '$1',
    tip: 1
  },
  {
    name: '$3',
    tip: 3
  },
  {
    name: '$5',
    tip: 5
  },
]

export const definition = {
  name: 'TipButtons',
  controller: Controller,
  initialProps: ({ tipValue }) => ({ tipValue }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(wrap(TableRow, TBodyWrapper), BorderCollapsedTableWrapper),
      name: 'Wrapper',
      elements: [
        {
          wrapper: Td,
          name: 'Button',
          isButton: true,
          isListOf: { tab: ({ }) => tabs },
          bindings: ({ tab }) => ({ tab }),
          displayState: ({ tab, tipValue, displayInput }) => ({ selected: !displayInput && tab.tip === tipValue }),
          elements: [
            {
              component: isMobile ? SecondaryTextXs : SecondaryTextSm,
              name: 'One',
              displayValue: ({ tab }) => tab.name,
            },
          ]
        },
        {
          wrapper: Td,
          name: 'Other',
          isButton: true,
          ref: containerRef,
          bindings: ({ }) => ({ containerRef }),
          displayState: ({ displayInput, tipValue }) => ({ input: displayInput, selected: !displayInput && tipValue && ![0, 1, 3, 5].includes(tipValue) }),
          elements: [
            {
              component: isMobile ? SecondaryTextXs : SecondaryTextSm,
              renderIf: ({ displayInput }) => !displayInput,
              name: 'Other',
              displayValue: ({ tipValue }) => tipValue && ![0, 1, 3, 5].includes(tipValue) ? `$ ${tipValue}` : 'Other'
            },
            {
              wrapper: FlexCenterWrapper,
              renderIf: ({ displayInput }) => displayInput,
              name: 'InputWrapper',
              elements: [
                {
                  component: isMobile ? SecondaryTextXs300 : SecondaryTextSm300,
                  name: 'Label',
                  displayValue: ({ }) => '$'
                },
                {
                  component: wrap(KeyInput, Width50),
                  name: 'Input',
                  bindings: ({ inputValue }) => ({ value: inputValue ?? '', placeholder: '' }),
                  displayState: ({ }) => ({ isBorder: 'no' })
                },
                {
                  component: Icon,
                  name: 'Icon',
                  displayValue: ({ }) => TickSvg({ color: '#1AAA60' })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);